import { Box } from '@components/Box';
import { Button } from '@components/Button';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { Text } from '@components/typography';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';
import styled from 'styled-components';
import {
  BACKGROUND_IMAGE,
  HEIGHT,
  WIDTH_BODY,
  WIDTH_BODY_MOBILE,
  WIDTH_BODY_XL,
  WIDTH_TITLE,
  WIDTH_TITLE_MOBILE,
  WIDTH_TITLE_XL,
} from './RoomBlockSection.constants';

export const StyledSection = styled(Box)<{ isVisible: boolean }>`
  background: url(${({ isVisible }) => (isVisible ? cloudAssetUrl(BACKGROUND_IMAGE.desktop, { optimization: 'mild' }) : '')}),
    linear-gradient(90deg, rgba(255, 255, 255, 0.6) 23.29%, rgba(255, 255, 255, 0.23) 41.39%, rgba(255, 255, 255, 0) 53.82%),
    linear-gradient(90deg, rgba(255, 255, 255, 0.6) -1.1%, rgba(255, 255, 255, 0.23) 49.03%, rgba(255, 255, 255, 0) 71.15%), lightgrey;
  height: ${HEIGHT};
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  ${themeMediaQuery('below_sm')} {
    background: none;
    height: auto;
    min-height: auto;
    display: flex;
    flex-direction: column;
    padding: ${themeSpace(8)} ${themeSpace(7)} ${themeSpace(12)};
  }
  ${themeMediaQuery('mobile')} {
    padding: ${themeSpace(6)} ${themeSpace(6)} ${themeSpace(10)};
    margin-bottom: ${themeSpace(5)} !important;
  }
  ${themeMediaQuery('tablet')} {
    img {
      object-position: bottom;
    }
  }
`;

export const TextContainer = styled(Flex)`
  top: 0;
  left: 0;
  z-index: 4;
  width: 100%;
  height: 100%;
  position: absolute;
  align-items: flex-start;
  ${themeMediaQuery('below_sm')} {
    position: relative;
    height: auto;
  }
  ${themeMediaQuery('tablet')} {
    margin-top: ${themeSpace(10)};
  }
  ${themeMediaQuery('sm')} {
    margin-top: 0;
    align-items: center;
  }
`;

export const LottieContainer = styled(Flex)`
  padding: 0px ${themeSpace(6)};
  width: 100%;
  min-height: 100%;
  ${themeMediaQuery('below_sm')} {
    padding: 0;
    min-height: auto;
  }
  ${themeMediaQuery('sm')} {
    width: fit-content;
    transform: scale(0.9);
  }
  ${themeMediaQuery('md')} {
    transform: scale(1);
    padding: 0px ${themeSpace(12)};
  }
`;

export const EyebrowWrapper = styled(Flex)`
  align-items: flex-end;
  ${themeMediaQuery('below_sm')} {
    align-items: center;
    justify-content: center;
    /* Override NewFlag's internal flex-direction for mobile */
    > div {
      flex-direction: row;
      align-items: center;
    }
  }
  ${themeMediaQuery('mobile')} {
    margin-bottom: ${themeSpace(3)};
    /* Remove gap and reduce eyebrow size */
    > div {
      gap: 0;
    }
    span {
      ${themeVariant('sectionEyeBrow16')};
    }
  }
`;

export const StyledText = styled(Text)`
  position: relative;
  bottom: ${themeSpace(5)};
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 432px;
    margin-bottom: ${themeSpace(5)};
    ${themeVariant('calloutHed28')}
  }
  .text-pairing-body {
    max-width: 432px;
    ${themeVariant('featureCopy16')}
  }
  ${themeMediaQuery('mobile')} {
    .text-pairing-title {
      font-size: 24px;
      line-height: 32px;
      margin-bottom: ${themeSpace(3)};
    }
  }
  ${themeMediaQuery('lg')} {
    .text-pairing-title {
      max-width: 502px;
      ${themeVariant('calloutHed32')}
    }
    .text-pairing-body {
      max-width: 502px;
      ${themeVariant('featureCopy17')}
    }
  }
`;

export const ExploreButton = styled(Button)`
  height: ${themeSpace(8)};
  border-width: 2px;
  ${themeMediaQuery('sm')} {
    height: ${themeSpace(9)};
    border-width: 2px;
  }
`;

export const ImageContainer = styled.div<{ isVisible: boolean }>`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    margin-top: ${themeSpace(6)};
    width: 100%;
    aspect-ratio: 16 / 10;
    border-radius: 16px;
    overflow: hidden;
    background: url(${({ isVisible }) => (isVisible ? cloudAssetUrl(BACKGROUND_IMAGE.mobile, { optimization: 'mild' }) : '')});
    background-size: cover;
    background-position: center bottom;
    background-repeat: no-repeat;
  }
  ${themeMediaQuery('mobile')} {
    margin-top: ${themeSpace(4)}; /* 12px for tighter spacing */
    border: 1px solid rgba(0, 0, 0, 0.06);
  }
`;
